import { illnesses } from "./illnesses/path";

import { hospitalization } from "@api/visitSummaryNotes/hospitalization/path";
import { surgeries } from "@api/visitSummaryNotes/surgeries/path";
import { allergies } from "@api/visitSummaryNotes/allergies/path";
import { medicines } from "@api/visitSummaryNotes/medicines/path";
import { familyIllnesses } from "@api/visitSummaryNotes/familyIllnesses/path";
import { symptoms } from "@api/visitSummaryNotes/symptoms/path";
import { images } from "@api/visitSummaryNotes/images/path";
import { experiments } from "@api/visitSummaryNotes/experiments/path";
import { prescriptions } from "@api/visitSummaryNotes/prescriptions/path";
import { diagnosis } from "@api/visitSummaryNotes/diagnosis/path";
import { referrals } from "@api/visitSummaryNotes/referrals/path";
import { vitalSigns } from "@api/visitSummaryNotes/vitalSigns/path";

export const visitSummaryNotes = {
  illnesses,
  hospitalization,
  surgeries,
  allergies,
  familyIllnesses,
  symptoms,
  medicines,
  images,
  experiments,
  prescriptions,
  diagnosis,
  referrals,
  vitalSigns,
};
